
import { useEffect, useContext } from 'react';

import Login from './Login';
import Home from './Home';
import { GlobalContext, HOST } from "./context/GlobalContext"

import Modal from 'react-bootstrap/Modal'

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './Loading.css';

function App() {
  const { logged, globalLoading, setLogged, setUserName, setRol, setName, showMesage, setShowMesage, mailTitle, mailBody, setCallback } = useContext(GlobalContext);

  useEffect(() => {
    var login = sessionStorage.getItem('lji_auth')

    if( login ) {
      setUserName( sessionStorage.getItem('lji_auth') )
      setName( sessionStorage.getItem('lji_name') )
      setRol( sessionStorage.getItem('lji_rol') )
      setLogged( true )
    } else {
      setLogged( false )
    }
  }, []);

  return (
    <div>
      <div className={ globalLoading ? 'lmask' : 'hide' }></div>

      <Modal size="sm" show={showMesage} onHide={ () => setShowMesage(false) }>
        <Modal.Header> 
          <div className='section-subtitle'> { mailTitle } </div>
        </Modal.Header>
        <Modal.Body>
          { mailBody }
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="cancel-btn" onClick={ () => setShowMesage(false) } >{ 'Cancelar' }</button>
          <button type="button" className="grl-btn" onClick={ () => setCallback(true) }>{ 'Aceptar' }</button>
        </Modal.Footer>
      </Modal>

      { logged ? <Home /> : <Login /> }

    </div>
  );
}

export default App;
